import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";
import { useDomainesQuery } from "../../cdsApiSlice";
import { Domaine } from "./CreateDomaine";
import styles from "./domaineManagement.module.scss";
import DomainsList from "./DomainsList";
import { useSecureApplication } from "../../../../hooks/KeycloackConnection";
import { useTranslation } from "react-i18next";
import { FieldElementSearch } from "../../../../components/list/FieldElementSearch";
import RenderLoading from "../../../../components/list/RenderLoading";
import { Message } from "primereact/message";
import { Paginator, PaginatorPageChangeEvent } from "primereact/paginator";
import { useAppDispatch, useAppSelector } from "../../../../hooks/hooks";
import { setDomainePagination } from "../../cdsSlice";
import { useNavigate } from "react-router-dom";

const DomainsPage = () => {
  const { t } = useTranslation();
  const [displayDomainCreationDialog, setDisplayDomainCreationDialog] =
    useState(false);
  const { hasAnyPerm } = useSecureApplication();
  const pagination = useAppSelector((state) => state.cds.domainePagination);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [first, setFirst] = useState<number>(0);

  const { data: domains, ...DomainStatus } = useDomainesQuery(pagination);

  const paginate = (event: PaginatorPageChangeEvent) => {
    dispatch(
      setDomainePagination({
        ...pagination,
        size: event.rows,
        page: event.page,
      })
    );
  };

  useEffect(() => {
    setFirst(pagination.page * pagination.size);
  }, [pagination.page]);

  return (
    <>
      <Domaine
        displayCreateDomaineDialog={displayDomainCreationDialog}
        add={DomainStatus.refetch}
        setter={() => {
          setDisplayDomainCreationDialog(false);
        }}
      />

      <div className={`${styles.DomaineManagement} workspacsSourceExterne`}>
        <div className={styles.toolbar}>
          <div className={`${styles.titleAndButtonDomainCreation}`}>
            <h2 className="ml-5 mt-3">Domaines</h2>
            {hasAnyPerm("gds.manage") && (
              <div
                className={`${styles.titleAndButtonDomainCreation} mr-5 mt-3`}
              >
                <Button
                  label={"Créer un domaine"}
                  className="p-button-sm"
                  style={{ backgroundColor: "#007fb0" }}
                  icon={"pi pi-plus"}
                  onClick={() => setDisplayDomainCreationDialog(true)}
                />
              </div>
            )}
          </div>

          <div className="ml-5 flex mb-2 align-items-center filAriane">
            <div
              onClick={() => navigate("/library/sources")}
              className="mr-2 cursor-pointer"
            >
              {t("title.data-catalog.sources")}
            </div>
            <i
              style={{ color: "#6c757d" }}
              className="pi pi-chevron-right mr-2"
            ></i>{" "}
            <div>Domaines</div>
          </div>
        </div>

        {DomainStatus.isLoading && RenderLoading(7)}
        {DomainStatus.isError && (
          <div className="m-5">
            <Message
              className="w-full"
              severity="error"
              text="Erreur de chargement des domaines"
            />
          </div>
        )}

        {!DomainStatus.isLoading && !DomainStatus.isError && (
          <div>
            <div className="m-4 mb-0">
              <FieldElementSearch
                value={pagination.search}
                changeValue={(filerValueChange: string) => {
                  dispatch(
                    setDomainePagination({
                      ...pagination,
                      page: 0,
                      search: filerValueChange,
                    })
                  );
                }}
                placeholder="Rechercher"
              />
            </div>
            {!DomainStatus.isLoading &&
              !DomainStatus.isError &&
              domains &&
              domains.data.length === 0 && (
                <div className="m-5">
                  <Message
                    className="w-full"
                    severity="info"
                    text="Aucun domaine"
                  />
                </div>
              )}

            {!DomainStatus.isLoading &&
              !DomainStatus.isError &&
              domains &&
              domains.data.length > 0 && (
                <>
                  <DomainsList domains={domains.data} />
                  <div style={{ alignItems: "center" }}>
                    <Paginator
                      first={first}
                      rows={pagination.size}
                      totalRecords={domains.total}
                      onPageChange={paginate}
                      style={{ backgroundColor: "#f6f7f9" }}
                    />
                  </div>
                </>
              )}
          </div>
        )}
      </div>
    </>
  );
};

export default DomainsPage;
